import {Component, OnInit} from '@angular/core';
import {InputText} from 'primeng/inputtext';
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ButtonDirective} from 'primeng/button';
import {Toast} from 'primeng/toast';
import {NgClass, NgStyle} from '@angular/common';
import {MessageService} from 'primeng/api';
import {Tooltip} from 'primeng/tooltip';

@Component({
    selector: 'app-registration',
    imports: [
        InputText,
        ReactiveFormsModule,
        ButtonDirective,
        FormsModule,
        Toast,
        NgStyle,
        NgClass,
        Tooltip,
    ],
    templateUrl: './registration.component.html',
    standalone: true,
    styleUrl: './registration.component.scss',
})
export class RegistrationComponent implements OnInit{
    form: any;
    showForm = false;
    passwordAgain: any;

    constructor(private formBuilder: FormBuilder, private messageService: MessageService) {
    }

    ngOnInit() {
        this.initForm()
    }

    initForm() {
        this.form = this.formBuilder.group({
            name: [null, Validators.required],
            neptunCode:[null, Validators.required],
            email: [null, Validators.required],
            password: [null, Validators.required],
            confirmPassword: [],
        }, {validators: this.passwordsMatchValidator})
    }

    submitForm() {
        Object.values(this.form.controls).forEach((control: any) => control.markAsDirty());
        this.form.markAllAsTouched();
        if (this.form.valid) {
            this.showSuccessMessage();
        } else {
            this.showErrorMessage();
        }
    }

    passwordsMatchValidator(group: any) {
        const passwordControl = group.get('password');
        const confirmPasswordControl = group.get('confirmPassword');
        if (!passwordControl || !confirmPasswordControl) return null;
        const password = passwordControl.value;
        const confirmPassword = confirmPasswordControl.value;
        if (password !== confirmPassword) {
            confirmPasswordControl.setErrors({ passwordsMismatch: true });
            return { passwordsMismatch: true };
        } else {
            if (confirmPasswordControl.hasError('passwordsMismatch')) {
                confirmPasswordControl.setErrors(null);
            }
            return null;
        }
    }

    showSuccessMessage() {
        this.messageService.add({severity: 'success', summary: 'Sikeres regisztráció!', detail: 'Regisztrációjat feldolgoztuk, és egy megerősítő emailt küldtünk a megadott címre.',
            key: 'center', sticky: true, closable: false});
    }

    showErrorMessage() {
        this.messageService.add({severity: 'error', summary: 'Nem megfelelő adatok', detail: 'Tekintse át az űrlapot, és a pirossal jelzett részeket javítsa!',
            key: 'center', sticky: true, closable: false});
    }

    clearToasts() {
        this.messageService.clear();
    }

}
